import './bootstrap'; // Optional: Import Bootstrap or other global setup files
import { createApp } from 'vue';
const app = createApp({});
app.mount('#app');
